import { render, staticRenderFns } from "./MovementsTable.vue?vue&type=template&id=0824e51f&scoped=true&lang=pug&"
import script from "./MovementsTable.vue?vue&type=script&lang=js&"
export * from "./MovementsTable.vue?vue&type=script&lang=js&"
import style0 from "./MovementsTable.vue?vue&type=style&index=0&id=0824e51f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824e51f",
  null
  
)

export default component.exports